import React from "react";

export interface ArrowProps {
  x1?: number;
  y1?: number;
  x2?: number;
  y2?: number;
  color?: string;
  strokeWidth?: number;
}

export const Arrow: React.FC<ArrowProps> = ({
  x1 = 50,
  y1 = 50,
  x2 = 150,
  y2 = 50,
  color = "#3b82f6",
  strokeWidth = 2,
}) => {
  const dx = x2 - x1;
  const dy = y2 - y1;
  const angle = Math.atan2(dy, dx);
  const arrowLength = 8;

  const arrowX1 = x2 - arrowLength * Math.cos(angle - Math.PI / 6);
  const arrowY1 = y2 - arrowLength * Math.sin(angle - Math.PI / 6);
  const arrowX2 = x2 - arrowLength * Math.cos(angle + Math.PI / 6);
  const arrowY2 = y2 - arrowLength * Math.sin(angle + Math.PI / 6);

  return (
    <g>
      <line x1={x1} y1={y1} x2={x2} y2={y2} stroke={color} strokeWidth={strokeWidth} />
      <line x1={x2} y1={y2} x2={arrowX1} y2={arrowY1} stroke={color} strokeWidth={strokeWidth} />
      <line x1={x2} y1={y2} x2={arrowX2} y2={arrowY2} stroke={color} strokeWidth={strokeWidth} />
    </g>
  );
};
